<div class="component-wrapper">
    <form [formGroup]="generalPartnerForm">
        <mat-card class="detail-card general-partner-cards-flex" id="details">
            <mat-card-header class="detail-card-header">
                <mat-card-title data-test="title">General Partner Details</mat-card-title>
            </mat-card-header>
            <mat-card-subtitle>
            </mat-card-subtitle>
            <mat-card-content class="detail-card-content">
                <div class="key-value-pair-section">
                    <div class="key-value-pair-column">
                        <div class="key-value-pair">
                            <div class="key-value-item">Name</div>
                            <div class="key-value-item">
                                @if (!isEditable) {
                                    {{ generalPartner.name | traceableFormat }}
                                }
                                @if (isEditable) {
                                    <input data-test="general-partner-name" formControlName="name" matInput/>
                                }
                            </div>
                        </div>
                        <valumize-mergeable-select-code
                            [codeTable]=codeTableGpQuality
                            [code]=generalPartner.quality
                            [control]=generalPartnerForm.controls.quality
                            [isEditable]=isEditable
                            [label]="'Quality'">
                        </valumize-mergeable-select-code>

                        <div class="key-value-pair ">
                            <div class="key-value-item">Description</div>
                            <div class="general-partner-description">
                                @if (isEditable) {
                                    <textarea [formControl]="generalPartnerForm.controls.comment"
                                              class="general-partner-description-form"
                                              data-test="general-partner-description"></textarea>
                                }
                                @if (!isEditable) {
                                    <div class="line-breaks">{{ generalPartner.comment | traceableFormat }}</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions class="detail-card-actions">
                @if (!isEditable) {
                    <button (click)="editMode()" [disabled]="(isEditDisabled$ | async)!" color="primary" data-test="edit-button" mat-icon-button>
                        <mat-icon>edit</mat-icon>
                    </button>
                }
                @if (isEditable) {
                    <button (click)="save()" [disabled]="generalPartnerForm.invalid" color="primary" data-test="save-button" mat-icon-button>
                        <mat-icon>save</mat-icon>
                    </button>
                }
                @if (isEditable) {
                    <button (click)="cancel()" color="primary" data-test="cancel-button" mat-icon-button>
                        <mat-icon>cancel</mat-icon>
                    </button>
                }
            </mat-card-actions>
        </mat-card>
    </form>
    <mat-card class="detail-card general-partner-cards-flex" id="comments">
        <mat-card-header class="detail-card-header">
            <mat-card-title data-test="title">Comments</mat-card-title>
        </mat-card-header>
        @let commentContext = (commentContext$ | async);
        <mat-card-content class="detail-card-content">
            @if (commentContext) {
                <valumize-comments-thread [context]="commentContext"></valumize-comments-thread>
            }
        </mat-card-content>
    </mat-card>
</div>
<mat-card class="detail-card" id="funds">
    <mat-card-header class="detail-card-header">
        <mat-card-title data-test="title">Funds</mat-card-title>
    </mat-card-header>
    <mat-card-content class="detail-card-content">
        <section class="table-container" tabindex="0">
            <valumize-fund-table [parentComponent]="'generalPartner'"
                                 [tableKey]="'general-partner-funds'"
                                 [showArchivedFilter]=true
                                 (fundClick)="navigateToFund($event)">
            </valumize-fund-table>
        </section>
    </mat-card-content>
</mat-card>
